export default __webpack_public_path__ + "static/media/resource.30e30ba5.svg";